<template>
  <div style="border: 2px solid grey">
    <pre class="mini-pre">{{message.$state}}</pre>
  </div>
</template>

<script>

export default {
  props: {
    message: {}
  },
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  components: {
  }
};
</script>

<style>
</style>
